import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
// import cookie from "@utils/store/cookie";

import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery } from "@utils";
Vue.use(animate);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function(rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;
// Vue.config.ignoredElements = ['wx-open-launch-weapp']
// let cookieName = "ajt-wechat";
let query = parseQuery();
// let urlSpread = query["spread"];
// let vconsole = query[cookieName.toLowerCase()];
// let md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2"; //CRMEB MD5 加密开启vconsole模式
// let md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式
if (query["share_uid"]) {
  store.commit("SHARE_UID", query["share_uid"]);
}

const _isWechat = isWeixin();

// if (vconsole !== undefined) {
//   if (vconsole === md5UnCrmeb && cookie.has(cookieName))
//     cookie.remove(cookieName);
// } else vconsole = cookie.get(cookieName);
//
// if (vconsole !== undefined && vconsole === md5Crmeb) {
//   cookie.set(cookieName, md5Crmeb, 3600);
//   const module = () => import("vconsole");
//   module().then(Module => {
//     new Module.default();
//   });
// }
if (_isWechat) {
  const module = () => import("@libs/wechat");
  module().then(Module => {
    Module.oAuth();
  });
}
const version = "v1.23.08.02.13";
Vue.prototype.$version = version;
const $vm = new Vue({
  router,
  store,
  version,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 100);
